import { cn } from '../../lib/utils';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const sizes = {
  sm: 'w-4 h-4',
  md: 'w-6 h-6',
  lg: 'w-8 h-8',
  xl: 'w-12 h-12'
};

export const LoadingSpinner = ({ size = 'md', className = '' }: LoadingSpinnerProps) => (
  <div 
    className={cn(
      'animate-spin rounded-full border-2 border-gray-300 border-t-blue-600',
      sizes[size],
      className
    )}
  />
);